import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import noop from 'lodash/noop';

import { AuditLog, LoadAuditLogsRequest } from '../../types/auditLog.ts';

export interface AuditLogState {
  auditLogs: AuditLog[];
  page: number;
  pageSize: number;
  totalElements: number;
  isLoading: boolean;
  error: string;
}

const initialState: AuditLogState = {
  auditLogs: [],
  page: 0,
  pageSize: 20,
  totalElements: 0,
  isLoading: false,
  error: '',
};

export const auditLogReducer = createSlice({
  name: 'auditLog',
  initialState,
  reducers: {
    loadAuditLogs: (state: AuditLogState, _action: PayloadAction<LoadAuditLogsRequest>) => {
      state.isLoading = true;
      state.error = '';
    },
    setAuditLogs: (
      state: AuditLogState,
      action: PayloadAction<{ content: AuditLog[]; page: number; pageSize: number; totalElements: number }>,
    ) => {
      state.auditLogs = action.payload.content;
      state.page = action.payload.page;
      state.pageSize = action.payload.pageSize;
      state.totalElements = action.payload.totalElements;
      state.isLoading = false;
      state.error = '';
    },
    setAuditLogsError: (state: AuditLogState, action: PayloadAction<string>) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    resetAuditLogs: () => {
      noop();
      return initialState;
    },
  },
});
